var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesManagementMenuIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7444 6.86385L3.7844 6.89385L3.7444 6.86385C3.62367 7.02483 3.5584 7.22063 3.5584 7.42185V19.7419C3.5584 20.4553 3.84181 21.1395 4.34628 21.644C4.85075 22.1484 5.53496 22.4319 6.2484 22.4319H18.5684C19.2819 22.4319 19.966 22.1484 20.4705 21.644C20.975 21.1395 21.2584 20.4553 21.2584 19.7419V7.42185C21.2584 7.22062 21.1931 7.02483 21.0724 6.86385L18.4324 3.34385L18.3924 3.37385L18.4324 3.34385C18.2567 3.10967 17.9812 2.97185 17.6884 2.97185H7.1284C6.83567 2.97185 6.56003 3.10967 6.3844 3.34385L3.7444 6.86385Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-white",
    d: "M3.37219 6.49187C2.85857 6.49187 2.44219 6.90825 2.44219 7.42187C2.44219 7.9355 2.85857 8.35187 3.37219 8.35187H21.6274C22.1411 8.35187 22.5574 7.9355 22.5574 7.42187C22.5574 6.90825 22.1411 6.49187 21.6274 6.49187H3.37219Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-white",
    d: "M9.81781 10.9419C9.81781 10.4283 9.40143 10.0119 8.88781 10.0119C8.37419 10.0119 7.95781 10.4283 7.95781 10.9419C7.95781 12.1221 8.42665 13.254 9.26119 14.0885C10.0957 14.9231 11.2276 15.3919 12.4078 15.3919C13.588 15.3919 14.7199 14.9231 15.5544 14.0885C16.389 13.254 16.8578 12.1221 16.8578 10.9419C16.8578 10.4283 16.4415 10.0119 15.9278 10.0119C15.4142 10.0119 14.9978 10.4283 14.9978 10.9419C14.9978 11.6288 14.7249 12.2876 14.2392 12.7733C13.7535 13.259 13.0947 13.5319 12.4078 13.5319C11.7209 13.5319 11.0621 13.259 10.5764 12.7733C10.0907 12.2876 9.81781 11.6288 9.81781 10.9419Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesManagementMenuIconFilled);
export default __webpack_public_path__ + "static/media/SalesManagementMenuIconFilled.7a6de40cdabaf7d247994fde3973eddb.svg";
export { ForwardRef as ReactComponent };